<template>
  <div class="contenedor-clients" >
    <h1 align="center" class="subtitle">Nuestros Clientes</h1>
    <div class="md-layout">
        <carousel-3d :space="carousel_width"  :autoplay="true" :perspective="0" :width="images.width" :height="images.height">
            <slide :index="0" >
                <img alt="Aspen" src="@/assets/clients/aspen.png">
            </slide>

            <slide :index="1" >
                <img alt="Cencosud" src="@/assets/clients/cencosud.png" style="margin-top: 3rem !important; ">
            </slide>

            <slide :index="2" >
                <img alt="Electricas" src="@/assets/clients/electricas.png" style="margin-top: 4.5rem !important; ">
            </slide>

            <slide :index="3" >
                <img alt="Enel" src="@/assets/clients/enel.png" style="margin-top: 2rem !important; ">
            </slide>

            <slide :index="4" >
                <img alt="Gasco" src="@/assets/clients/gasco.png" style="margin-top: 3.5rem !important; ">
            </slide>

            <slide :index="5" >
                <img alt="Iansa" src="@/assets/clients/iansa.svg" style="margin-top: 2rem !important; ">
            </slide>

            <slide :index="6" >
                <img alt="Loreal" src="@/assets/clients/loreal.png" style="margin-top: 2rem !important; ">
            </slide>

            <slide :index="7" >
                <img alt="Parque Arauco" src="@/assets/Logo_Parque_Arauco.svg.png" style="width: 90%; height: 60%; margin: 1rem 1rem 0rem 1rem">
            </slide>

            <slide :index="8" >
                <img alt="Pesco" src="@/assets/clients/pesco.png" style="margin-top: 3.5rem !important; ">
            </slide>

            <slide :index="9" >
                <img alt="Recti" src="@/assets/clients/recti.png" style="width: 60%; height: 60%; margin: 1rem 1rem 0rem 3rem">
            </slide>
        </carousel-3d>
    </div>
  </div>
</template>

<script>
export default {
    data () {
        return {
            images: {
                width: 200,
                height: 200
            },
            carousel_width: 300
        }
    },
    mounted () {
        this.getScreenSize()
    },
    methods: {
        getScreenSize () {
            var width = window.screen.width
            if (width === 1980) {
                this.carousel_width = 500
                this.images.width = 300
                this.images.height = 300
            } else if (width === 1024) {
                this.carousel_width = 250
                this.images.width = 180
                this.images.height = 180
            } else if (width > 1600) {
                this.carousel_width = 400
                this.images.width = 250
                this.images.height = 250
            }
        }
    }
}
</script>

<style>
.carousel-3d-slide {
    background-color: #fafafa !important;
    border-color: #fafafa !important;

}
.subtitle {
    font-size: 3.5vw;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.93;
    letter-spacing: normal;
}
.contenedor-clients {
    margin: 2vh 0vh 4vh 0vh;
}
.contenedor-clients > h1 {
    margin: 10vh 0vh 5vh 0vh;
}
</style>